import React, { useState } from "react";

function ListItem({ publication }) {
  const [localPublication] = useState(publication);
  
  return (
    <div className="row mb-4 ">
      <div className="col-lg-3 col-md-6 col-sm-12">
        <img src={ localPublication.image?.[0]?.signedUrl } className="img-fluid" alt="" />
        
      </div>
      <div className="col-lg-9 col-md-6 col-sm-12 d-flex flex-column justify-content-around">
        <div>
          <h6 className="fw-bold text-decoration-underline mt-3">{ localPublication.title }</h6>
          <p className="small">
            { localPublication.description }
          </p>
        </div>
        <p className="text-secondary small fst-italic">
          {
            `Publié le ${new Date(localPublication.date).toLocaleDateString('fr-FR')}`
          }
          {
            localPublication.publisher &&
            <><br/>Avec <b>{localPublication.publisher}</b></>
          }
          {
            localPublication.link &&
            <><br/><a href={localPublication.link} target="_blank" rel="noopener noreferrer">{localPublication.textlink}</a></>
          }
          
        </p>
      </div>
    </div>
  );
}

export default ListItem;